<!-- <div class="row">
    <div class="col-12" style="margin-top: 100px;">

    </div>
</div> -->

<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>
<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100 p-md-5 wrap-content">
                                <h3>
                                    Reset Password
                                </h3>
                                <form id="resetPasswordForm" *ngIf="!successMessage" [formGroup]="resetPasswordForm" name="resetPasswordForm" class="resetPasswordForm" method="POST">
                                    <div class="row">
                                        <!-- <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="text" class="form-control" name="old_password"
                                                    id="old_password" placeholder="Old Password"
                                                    formControlName="old_password"
                                                    [class.is-invalid]="resetPasswordForm.get('old_password')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Old Password is required.
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col-md-12 mt-2">
                                            <div class="form-group">
                                                <input type="password" class="form-control" name="new_password"
                                                    id="new_password" placeholder="New Password"
                                                    formControlName="new_password"
                                                    [class.is-invalid]="resetPasswordForm.get('new_password')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    New Password is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12m mt-3">
                                            <div class="form-group">
                                                <input type="password" class="form-control" name="re_new_password"
                                                    id="re_new_password" placeholder="Re-Enter New Password"
                                                    formControlName="re_new_password"
                                                    [class.is-invalid]="resetPasswordForm.get('re_new_password')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Phone Number is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mt-1">
                                            <div class="form-group">
                                                <button type="button" (click)="onSubmit()" 
                                                    class="btn btn-primary">Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div *ngIf="isSubmitted && successMessage" class="alert alert-success mt-3" role="alert">
                                    <p class="success-message">{{ successMessage }}</p>
                                </div>
                                <!-- <div class="w-100 social-media mt-5">
                                    <h3>
                                        Follow us here
                                    </h3>
                                    <p>
                                        <a href="#">Facebook</a>
                                        <a href="#">Twitter</a>
                                        <a href="#">Instagram</a>
                                        <a href="#">Dribbble</a>
                                    </p>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex align-items-stretch">
                            <div id="map" class="bg-white"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <div class="mb-3">
    <label for="phoneNumber" class="form-label">Phone Number</label>
    <div class="input-group">
        <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="countryDropdown" data-bs-toggle="dropdown">
                <img class="flag-img" src="../../assets/images/united_arab_emirates.png"> +971
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" href="#" data-value="+91"><img class="flag-img" src="../../assets/images/india.png" alt="India Flag"> +91</a>
                <a class="dropdown-item" href="#" data-value="+971"><img class="flag-img" src="../../assets/images/united_arab_emirates.png" alt="UAE Flag"> +971</a>
            </div>
        </div>
        <input type="tel" class="form-control" id="phoneNumber" placeholder="Enter your phone number" required>
    </div>
</div> -->
